/** Transport and playback icons. */

import type { Component } from 'solid-js';
import { Svg } from './Svg.tsx';

export const Previous: Component = () => (
  <Svg>
    <path d="M17.5 6.4v11.2L9.2 12z" class="fill" />
    <path d="M6.9 6.2v11.6" />
  </Svg>
);

export const Next: Component = () => (
  <Svg>
    <path d="M6.5 6.4v11.2L14.8 12z" class="fill" />
    <path d="M17.1 6.2v11.6" />
  </Svg>
);

export const Play: Component = () => (
  <Svg>
    <path d="M8.6 5.6 19 12 8.6 18.4z" class="fill" />
  </Svg>
);

export const Pause: Component = () => (
  <Svg>
    <path d="M9.2 6v12M14.8 6v12" stroke-width="2.6" />
  </Svg>
);

export const Shuffle: Component = () => (
  <Svg>
    <path d="M4 7h3.4l9 10h3.2M4 17h3.4l2.4-2.7M14.5 9.3 16.6 7h3.6" />
    <path d="m17.8 4.4 2.8 2.6-2.8 2.4M17.8 14.4l2.8 2.6-2.8 2.4" />
  </Svg>
);

export const Repeat: Component = () => (
  <Svg>
    <path d="M7 6.8h9.4a3.3 3.3 0 0 1 3.3 3.3v.6M17 17.2H7.6a3.3 3.3 0 0 1-3.3-3.3v-.6" />
    <path d="m16.8 4.4 3 2.4-3 2.4M7.2 19.6l-3-2.4 3-2.4" />
  </Svg>
);

export const VolumeOn: Component = () => (
  <Svg>
    <path d="M5 9.6h3.1L12 6.2v11.6L8.1 14.4H5z" class="fill" />
    <path d="M15.3 9.6a3.4 3.4 0 0 1 0 4.8M17.8 7.2a6.8 6.8 0 0 1 0 9.6" />
  </Svg>
);

export const VolumeOff: Component = () => (
  <Svg>
    <path d="M5 9.6h3.1L12 6.2v11.6L8.1 14.4H5z" class="fill" />
    <path d="M15.4 9.8l4.4 4.4M19.8 9.8l-4.4 4.4" />
  </Svg>
);

export const Note: Component = () => (
  <Svg>
    <path d="M9 17.4V5.8l10-1.9v11.3" />
    <ellipse cx="6.6" cy="17.6" rx="2.6" ry="2.2" class="fill" />
    <ellipse cx="16.6" cy="15.4" rx="2.6" ry="2.2" class="fill" />
  </Svg>
);

export const Heart: Component = () => (
  <Svg>
    <path
      d="M12 19.2S4.6 14.6 4.6 9.7A3.9 3.9 0 0 1 12 7.6a3.9 3.9 0 0 1 7.4 2.1c0 4.9-7.4 9.5-7.4 9.5z"
      class="fill"
    />
  </Svg>
);
